import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

export default function ResetPassword() {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Die Passwörter stimmen nicht überein.");
      return;
    }
    if (password.length < 8) {
      setMessage("Das Passwort muss mindestens 8 Zeichen lang sein.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch("/api/password-reset-confirm/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uidb64: uid,
          token: token,
          new_password: password,
        }),
      });

      const data = await response.json();
      if (response.ok && data.ok) {
        setIsSuccess(true);
        setMessage("Dein Passwort wurde erfolgreich geändert. Du kannst dich jetzt einloggen.");
      } else {
        setMessage(data.text || "Ein Fehler ist aufgetreten.");
      }
    } catch (error) {
      setMessage("Ein Fehler ist aufgetreten. Bitte versuche es später noch einmal.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          marginBottom: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
          padding: 4,
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
          Neues Passwort vergeben
        </Typography>

        {message && (
          <Alert severity={isSuccess ? "success" : "error"} sx={{ mb: 2, width: "100%" }}>
            {message}
          </Alert>
        )}

        {!isSuccess ? (
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: "100%" }}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Neues Passwort"
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="confirmPassword"
              label="Passwort bestätigen"
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
              color="primary"
            >
              {loading ? "Wird gespeichert..." : "Passwort speichern"}
            </Button>
          </Box>
        ) : (
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={() => navigate("/login")}
            color="primary"
          >
            Zurück zum Login
          </Button>
        )}
      </Box>
    </Container>
  );
}
